export default {
    list: [
        {
            "id": "1712558913136",
            "parent_id": null,
            "name": "VERTEX",
            "sort": 0,
            "create_time": "2026-03-18T02:40:01.000Z",
            "children": [
                {
                "id": "1773801706461",
                "name": "Crushing Equipment",
                "children": [
                    {
                    "name": "Gyratory Crusher",
                    "children": [
                        {
                        "name": "HGT Series Gyratory Crusher",
                        "children": [
                            { "name": "HGT4265" },
                            { "name": "HGT5065" }
                        ]
                        }
                    ]
                    },
                    {
                    "name": "Jaw Crusher",
                    "children": [
                        {
                        "name": "C6X Series Jaw Crusher"
                        },
                        {
                        "name": "C5X Series Jaw Crusher",
                        "children": [
                            { "name": "C6X80" },
                            { "name": "C6X100" },
                            { "name": "C6X110" },
                            { "name": "C6X125" },
                            { "name": "C6X145" },
                            { "name": "C6X160" }
                        ]
                        },
                        {
                        "name": "PEW Series Jaw Crusher",
                        "children": [
                            { "name": "PEW760" },
                            { "name": "PEW860" }
                        ]
                        },
                        {
                        "name": "PE Series Jaw Crusher",
                        "children": [
                            { "name": "PE600x900" },
                            { "name": "PE750x1060" },
                            { "name": "PE900x1200" },
                            { "name": "PE1000x1200" },
                            { "name": "PE1200x1500 (003)" },
                            { "name": "PE1200x1500 (001)" }
                        ]
                        }
                    ]
                    },
                    {
                    "name": "Impact Crusher",
                    "children": [
                        {
                        "name": "CI5X Series Impact Crusher",
                        "children": [
                            { "name": "CI5X1213" },
                            { "name": "CI5X1315 (001)" },
                            { "name": "CI5X1315 (003)" },
                            { "name": "CI5X1415 (Trial Sale)" },
                            { "name": "CI5X1520" },
                            { "name": "CI5X1524" },
                            { "name": "CI5X1620 (Trial Sale)" },
                            { "name": "CI5X1630 (Trial Sale)" },
                            { "name": "CI5X2030 (Trial Sale)" }
                        ]
                        },
                        {
                        "name": "PFW Series Impact Crusher",
                        "children": [
                            { "name": "PFW1214 II (Discontinued)" },
                            { "name": "PFW1315 II (Discontinued)" },
                            { "name": "PFW1318 II (Discontinued)" },
                            { "name": "PFW1415 II (Discontinued)" },
                            { "name": "PFW1214 III" },
                            { "name": "PFW1315 III" },
                            { "name": "PFW1318 III (Discontinued)" },
                            { "name": "PFW1415 III" }
                        ]
                        },
                        {
                        "name": "PF Series Impact Crusher",
                        "children": [
                            { "name": "PF1010" },
                            { "name": "PF1210" },
                            { "name": "PF1214" },
                            { "name": "PF1315" }
                        ]
                        }
                    ]
                    },
                    {
                    "name": "Cone Crusher",
                    "children": [
                        {
                        "name": "HPT Series Multi-cylinder Hydraulic Cone Crusher",
                        "children": [
                            { "name": "HPT300" },
                            { "name": "HPT500" },
                            { "name": "HPT800 (Trial Sale)" }
                        ]
                        },
                        {
                        "name": "HST Series Single-cylinder Hydraulic Cone Crusher",
                        "children": [
                            { "name": "HST100H" },
                            { "name": "HST100S" },
                            { "name": "HST160H" },
                            { "name": "HST160S" },
                            { "name": "HST250H" },
                            { "name": "HST250S" },
                            { "name": "HST315H" },
                            { "name": "HST315S" },
                            { "name": "HST450S (Trial Sale)" },
                            { "name": "HST600H (Trial Sale)" },
                            { "name": "HST750H (Trial Sale)" }
                        ]
                        }
                    ]
                    },
                    {
                    "name": "Vertical Shaft Impact Crusher",
                    "children": [
                        {
                        "name": "VSI6X Series Vertical Shaft Impact Crusher",
                        "children": [
                            { "name": "VSI6X8015" },
                            { "name": "VSI6X9026" },
                            { "name": "VSI6X1040" },
                            { "name": "VSI6X1150" },
                            { "name": "VSI6X1263" },
                            { "name": "VSI6X1150G" },
                            { "name": "VSI6X1263G" },
                            { "name": "VSI6X1380G" },
                            { "name": "VSI6X13100G" },
                            { "name": "VSI6X1040Z (Trial Sale)" },
                            { "name": "VSI6X1150Z (Trial Sale)" },
                            { "name": "VSI6X1263Z (Trial Sale)" }
                        ]
                        },
                        {
                        "name": "VSI5X Series Vertical Shaft Impact Crusher",
                        "children": [
                            { "name": "VSI5X7615" },
                            { "name": "VSI5X8522" },
                            { "name": "VSI5X9532" },
                            { "name": "VSI5X1145" }
                        ]
                        },
                        {
                        "name": "VSI Series Vertical Shaft Impact Crusher",
                        "children": [
                            { "name": "VSI7611" },
                            { "name": "VSI8518" },
                            { "name": "VSI9526" },
                            { "name": "VSI1140" }
                        ]
                        }
                    ]
                    }
                ]
                },
                {
                    "id": "1773801854300",
                    "name": "Feeding & Screening Equipment",
                    "children": [
                        {
                        "name": "Feeder",
                        "children": [
                            {
                            "name": "F5X Series Vibrating Feeder",
                            "children": [
                                { "name": "F5X1045" },
                                { "name": "F5X1045M" },
                                { "name": "F5X1345" },
                                { "name": "F5X1345M" },
                                { "name": "F5X1360" },
                                { "name": "F5X1360S" },
                                { "name": "F5X1645" },
                                { "name": "F5X1645M" },
                                { "name": "F5X1660" },
                                { "name": "F5X1660S" },
                                { "name": "F5X2060" }
                            ]
                            },
                            {
                            "name": "F5X-G Series Vibrating Feeder"
                            },
                            {
                            "name": "GF Series Vibrating Feeder",
                            "children": [
                                { "name": "GF0942" },
                                { "name": "GF0942M" },
                                { "name": "GF0942S" },
                                { "name": "GF1245" },
                                { "name": "GF1245M" },
                                { "name": "GF1245S" }
                            ]
                            },
                            {
                            "name": "SP Series Vibrating Feeder",
                            "children": [
                                { "name": "SP0816" },
                                { "name": "SP0816Z" },
                                { "name": "SP1220" },
                                { "name": "SP1220Z" },
                                { "name": "SP1623Z" }
                            ]
                            }
                        ]
                        },
                        {
                        "name": "Vibrating Screen",
                        "children": [
                            {
                            "name": "S5X Series Vibrating Screen",
                            "children": [
                                { "name": "S5X1545-2" },
                                { "name": "S5X1545-3" },
                                { "name": "S5X1845-2" },
                                { "name": "S5X1845-3" },
                                { "name": "S5X1860-2" },
                                { "name": "S5X1860-3" },
                                { "name": "S5X1860-4" },
                                { "name": "S5X2160-2" },
                                { "name": "S5X2160-3" },
                                { "name": "S5X2160-4" },
                                { "name": "S5X2460-2" },
                                { "name": "S5X2460-3" },
                                { "name": "S5X2460-4" },
                                { "name": "S5X2760-2" },
                                { "name": "S5X2760-3" },
                                { "name": "S5X3072-2" },
                                { "name": "S5X3075-2T" },
                                { "name": "S5X3075-3T" },
                                { "name": "S5X3680-2T6" },
                                { "name": "S5X3680-3T" },
                                { "name": "S5X3685-2T (Trial Sale)" },
                                { "name": "S5X3685-3T (Trial Sale)" }
                            ]
                            },
                            {
                            "name": "Y Series Vibrating Screen",
                            "children": [
                                { "name": "2Y1237" },
                                { "name": "3Y1237" },
                                { "name": "4Y1237" },
                                { "name": "2Y1548" },
                                { "name": "3Y1548" },
                                { "name": "4Y1548" },
                                { "name": "2Y1848" },
                                { "name": "3Y1848" },
                                { "name": "4Y1848" },
                                { "name": "2Y1860" },
                                { "name": "3Y1860" },
                                { "name": "4Y1860" },
                                { "name": "2Y2160" },
                                { "name": "3Y2160" },
                                { "name": "4Y2160" },
                                { "name": "2Y2460" },
                                { "name": "3Y2460" },
                                { "name": "4Y2460" }
                            ]
                            }
                        ]
                        }
                    ]
                    },
                {
                    "id": "1773802326100",
                    "name": "Purchased Equipment / Electrical Control / Standard Parts / Motors / Bearings / Screen Mesh (Auxiliary Equipment)",
                    "children": [
                        {
                        "name": "Jaw Crusher (Purchased)",
                        "children": [
                            {
                            "name": "Jaw Crusher (PEW/PE)",
                            "children": [
                                { "name": "PEW400x600" },
                                { "name": "PEW250x1000" },
                                { "name": "PEW250x1200" }
                            ]
                            }
                        ]
                        },
                        {
                        "name": "Cone Crusher (Purchased)",
                        "children": [
                            {
                            "name": "CS Series Cone Crusher",
                            "children": [
                                { "name": "CS75" },
                                { "name": "CS160" }
                            ]
                            },
                            {
                            "name": "PY Series Parts (Great Wall)",
                            "children": [
                                { "name": "PY600" },
                                { "name": "PY900" },
                                { "name": "PY1200" }
                            ]
                            },
                            {
                            "name": "CS Series Parts (Great Wall)",
                            "children": [
                                { "name": "CS75" },
                                { "name": "CS160" },
                                { "name": "CS240" }
                            ]
                            }
                        ]
                        },
                        {
                        "name": "Impact Crusher",
                        "children": [
                            { "name": "PF1010" },
                            { "name": "PF1210" },
                            { "name": "PF1214" },
                            { "name": "PF1315" }
                        ]
                        },
                        {
                        "name": "Hammer Crusher",
                        "children": [
                            { "name": "PC400x300" },
                            { "name": "PC600x400" },
                            { "name": "PC800x600" },
                            { "name": "PC1000x800" },
                            { "name": "PC1200x1000" }
                        ]
                        },
                        {
                        "name": "Sand Washer",
                        "children": [
                            {
                            "name": "LSX Series Spiral Sand Washer",
                            "children": [
                                { "name": "LSX920" },
                                { "name": "2LSX920" },
                                { "name": "LSX1120" },
                                { "name": "2LSX1120" }
                            ]
                            }
                        ]
                        }
                    ]
                    }
            ]
        }
    ]
}